<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'임직원 검색'"
      :modal="true"
      :width="'800px'"
      @open="onOpenWindow"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="w100">
      <ul>
        <li class="w100">
          <kendo-tabstrip>
            <ul>
              <li v-show="!$props.isSamsungOnly" class="k-state-active" @click="tabIndex = 0"> 삼성 전자 </li>
              <li @click="tabIndex = 1"> 직접 입력 </li>
            </ul>
          </kendo-tabstrip>
        </li>
        <div v-show="tabIndex === 0">
          <li class="w100 mgt10">
            <kendo-dropdownlist
                class="mgl10 w20"
                ref="searchOptionRef"
                :data-source="searchOptionList"
            >
            </kendo-dropdownlist>
            <kendo-maskedtextbox
                class="mgl10 w60"
                ref="searchValueRef"
                id="searchValue"
                :placeholder="'검색값을 입력해주세요.'"
            >
            </kendo-maskedtextbox>
            <button class="f_r w15 mid_btn orange" @click="commonOnChangeEvent">검색</button>
          </li>
          <li class="w100">
            <kendo-grid
                class="basic_table mgt10"
                ref="userGridRef"
                :columns="sendNmColumns"
                :data-source="userDataSource"
                :selectable="'row'"
                :navigatable="true"
                :filterable="false"
                :sortable="false"
                :scrollable="true"
                :pageable-always-visible="true"
                :reorderable="true"
                :column-menu="false"
                @change="onChangeGrid"
                :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
            >
            </kendo-grid>
          </li>
        </div>
        <div v-show="tabIndex === 1">
          <ul class="mgt10 filter_list w100">
            <li>
              <dd>
                <label>이름<span class="forg">*</span></label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                        class="w100"
                        v-model="senderData.userNm"
                        :placeholder="'이름을 입력해주세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
              <dd>
                <label>아이디</label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                        class="w100"
                        v-model="senderData.userId"
                        :placeholder="'아이디를 입력해주세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>부서<span class="forg">*</span></label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                        class="w100"
                        v-model="senderData.deptNm"
                        :placeholder="'부서를 입력해주세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
              <dd>
                <label>전화번호<span class="forg">*</span></label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                        class="w100"
                        v-model="senderData.userTelNo"
                        :placeholder="'전화번호를 입력해주세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>사번<span class="forg">*</span></label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                        class="w100"
                        v-model="senderData.sabun"
                        :placeholder="'사번을 입력해주세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
              <dd>
                <label>이메일<span class="forg">*</span></label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                        class="w100"
                        v-model="senderData.userEmail"
                        :placeholder="'이메일을 입력해주세요'"
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
          </ul>
        </div>
      </ul>
      <div class="w100">

      </div>
    </div>
    <div class="button_area w40">
      <ul>
        <li class="w40"><button class="large_btn orange" @click="emitSendNm">저장</button></li>
        <li class="w40"><button class="large_btn" @click="closeWindow">취소</button></li>
      </ul>
    </div>
  </kendo-window>
</template>

<script>
import ApiConfig from "@/api/api.config";

export default {
  name: "SearchSendNm",
  props: {
    isSamsungOnly : {
      type : Boolean,
      required : false,
      default : function (){
        return false
      }
    },
  },
  created() {
    const vm = this
    vm.getUtopiaUserData()
  },
  mounted() {
    const vm = this

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'searchValue'
    ]

    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
  },
  methods: {

    onOpenWindow () {
      const vm = this

      // 검색칸 초기화
      vm.$refs.searchOptionRef.kendoWidget().select(0)
      vm.$refs.searchValueRef.kendoWidget().value('')
      vm.getUtopiaUserData()
    },

    commonOnChangeEvent () {
      const gridRefs = this.$refs.userGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        gridRefs.kendoWidget().dataSource.page(1)
      }
    },

    currentPageFilterOption () {
      const refs = this.$refs

      let filterOption = {}

      let searchValue = ""
      if (refs.searchValueRef !== undefined && refs.searchValueRef !== null) {
        searchValue = refs.searchValueRef.kendoWidget().value()
      }

      if (refs.searchOptionRef !== undefined && refs.searchOptionRef !== null) {
        const searchOption = refs.searchOptionRef.kendoWidget().value()
        if (searchOption === '이름') {
          filterOption.searchUserNm = searchValue
        } else if (searchOption === '부서') {
          filterOption.searchDeptNm = searchValue
        } else if (searchOption === '아이디') {
          filterOption.searchUserId = searchValue
        } else if (searchOption === '번호') {
          filterOption.searchUserTelNo = searchValue
        }
      }

      return filterOption
    },

    getUtopiaUserData () {
      const vm = this
      vm.userDataSource = [
        {
          userNm: "이윤성",
          deptNm: "기업부설연구소",
          userId: "oxide8689@etners.com",
          userEmail: "oxide8689@etners.com",
          userTelNo: "01000000000",
          sabun: "1111",
          rank: "직원",
          position: null,
        },
        {
          userNm: "임상현",
          deptNm: "기업부설연구소",
          userId: "sgus0608@etners.com",
          userEmail: "sgus0608@etners.com",
          userTelNo: "01200000000",
          sabun: "2222",
          rank: "직원",
          position: null,
        },
        {
          userNm: "김도현",
          deptNm: "기업부설연구소",
          userId: "dohyunhi24@etners.com",
          userEmail: "dohyunhi24@etners.com",
          userTelNo: "01049022121",
          sabun: "2222",
          rank: "직원",
          position: null,
        },
        {
          userNm: "삼성임직원1",
          deptNm: "부서1",
          userId: "test01@ss.com",
          userEmail: "chaeRin0525@etners.com",
          userTelNo: "01000000000",
          sabun: "1111",
          rank: "직원",
          position: null,
        },
        {
          userNm: "삼성임직원2",
          deptNm: "부서2",
          userId: "test02@ss.com",
          userEmail: "chaeRin0525@etners.com",
          userTelNo: "01200000000",
          sabun: "2222",
          rank: "직원",
          position: null,
        },
        {
          userNm: "독고길동",
          deptNm: "Test Process Design & 제품 Management\n",
          userId: "gildong01@etners.com",
          userEmail: "chaeRin0525@etners.com",
          userTelNo: "01000000000",
          sabun: "0515",
          rank: "직원",
          position: null,
        },
      ]
    },

    onChangeGrid (e) {
      const vm = this

      const selectedRow = e.sender.select()
      const item = e.sender.dataItem(selectedRow)

      vm.senderData = item
    },

    emitSendNm () {
      const vm = this
      const refs = vm.$refs

      vm.$emit('getSenderData', {
        userNm: vm.senderData.userNm,
        userId: vm.senderData.userId,
        dept: vm.senderData.deptNm,
        spTelNo: vm.senderData.userTelNo,
        sabun: vm.senderData.sabun,
        userEmail: vm.senderData.userEmail,
      })
      refs.kendoWindowRef.kendoWidget().close()
    },

    closeWindow () {
      const vm = this
      const refs = vm.$refs
      vm.senderData = {}

      refs.kendoWindowRef.kendoWidget().close()
    }
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    return {
      loginUserToken: sessionStorage.getItem("loginUserToken"),
      senderData : {},

      searchOptionList : [
          '이름', '부서', '아이디', '번호'
      ],

      tabIndex: 0,

      userDataSource : [],
      sendNmColumns : [
        {
          field: 'userNm',
          title: '이름',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'deptNm',
          title: '부서',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'userId',
          title: '아이디',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'userTelNo',
          title: '번호',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>